import { Injectable } from '@angular/core';
import { getAngularJSService, LegacyCookiesService } from '../ng-upgrade.utils';

interface LegacySecurityService {
  hasPermission(root: string): boolean;
  hasTokenUsers(): boolean;
  getToken(): string | false;
  getRefreshToken(): string | false;
  startLogin(data: unknown): string;
  removeLoggedUser(): void;
  urlStartsWithBaseApiUrl(url: string): boolean;
}

const DEVICE_TOKEN_COOKIE = 'deviceToken';

@Injectable({ providedIn: 'root' })
export class SecurityService {
  private legacy: LegacySecurityService | null = null;
  private cookiesService: LegacyCookiesService | null = null;

  private get security(): LegacySecurityService {
    if (this.legacy) {
      return this.legacy;
    }
    const svc = getAngularJSService<LegacySecurityService>('securityService');
    if (!svc) {
      throw new Error(
        'securityService AngularJS não disponível. AngularJS pode não ter sido bootstrapped.'
      );
    }
    this.legacy = svc;
    return this.legacy;
  }

  private get cookies(): LegacyCookiesService | null {
    if (!this.cookiesService) {
      this.cookiesService = getAngularJSService<LegacyCookiesService>('$cookies');
    }
    return this.cookiesService;
  }

  hasPermission(permission: string): boolean {
    // WRAPPER — reescrever com HttpClient quando securityService.js for removido
    return this.security.hasPermission(permission);
  }

  hasTokenUsers(): boolean {
    // WRAPPER — reescrever com HttpClient quando securityService.js for removido
    return this.security.hasTokenUsers();
  }

  getToken(): string | null {
    // WRAPPER — reescrever com HttpClient quando securityService.js for removido
    const token = this.security.getToken();
    return token ? token : null;
  }

  getRefreshToken(): string | null {
    // WRAPPER — reescrever com HttpClient quando securityService.js for removido
    const token = this.security.getRefreshToken();
    return token ? token : null;
  }

  startLogin(data: unknown): void {
    // WRAPPER — reescrever com HttpClient quando securityService.js for removido
    this.security.startLogin(data);
  }

  removeLoggedUser(): void {
    // WRAPPER — reescrever com HttpClient quando securityService.js for removido
    this.security.removeLoggedUser();
  }

  urlStartsWithBaseApiUrl(url: string): boolean {
    // WRAPPER — reescrever com HttpClient quando securityService.js for removido
    return this.security.urlStartsWithBaseApiUrl(url);
  }

  getDeviceTokenCookie(): string | null {
    // WRAPPER — ler o cookie direto quando o AngularJS for removido
    const token = this.cookies?.get(DEVICE_TOKEN_COOKIE);
    return token ? token : null;
  }
}
